/**
 * Lead Search Service - Handles lead search operations
 */

import api from "../../../shared/api";

/**
 * Search leads by name, phone, email, or reference number
 * @param {string} searchTerm - Search term
 * @param {Object} [options] - Search options
 * @param {boolean} [options.includeQuotedStatus] - Include hasQuote flag for each lead
 * @returns {Promise<Array>} Array of matching leads
 */
export const searchLeads = async (searchTerm, options = {}) => {
  try {
    if (!searchTerm || searchTerm.trim().length < 2) {
      return [];
    }

    const params = { q: searchTerm.trim() };
    if (options.includeQuotedStatus) {
      params.includeQuotedStatus = "true";
    }

    const response = await api.get("/leads/search", { params });

    return response.data?.leads || response.leads || [];
  } catch (error) {
    console.error("Error searching leads:", error);
    return [];
  }
};
